module.exports = __webpack_public_path__ + "img/ss-title.ed4f97db.png";